import { flatten } from "ramda"
import { depositStatges } from "./depositaccounts"
import { personalLoanStages } from "./personalloans"
import { smallBusinessLoanStages } from "./smallbusiness"
import { mortgageAndCommercialLoanStages } from "./mortgage"
import { fundaloanStages } from "./fundaloan"
import { cardsStages } from "./cards"



export const attuneLoanStages = flatten([
  depositStatges,
  personalLoanStages,
  cardsStages,
  fundaloanStages,
  mortgageAndCommercialLoanStages,
  smallBusinessLoanStages

])